/* ExpandCollapseComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ExpandCollapseRenderer");

class ExpandCollapseComponent extends EventEmitter {
    constructor() {
        super();
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _clickEventHandler(/*event*/) {
        if (this._expanded === false) {
            this.expand();
            this.emit("UserExpanded");
        } else {
            this.collapse();
            this.emit("UserCollapsed");
        }
        this.emit("UserChange");
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    expand() {
        this._expanded = true;
        this.emit("Expanded");
    }

    collapse() {
        this._expanded = false;
        this.emit("Collapsed");
    }

    isExpanded() {
        return this._expanded;
    }
    isCollapsed() {
        return !this.isExpanded();
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ExpandCollapseComponent;
